/**
 * SYNQ Logo — official brand mark.
 * Renders /synq-mark.png (the hexagonal wireframe symbol) at a fixed square size.
 *
 * Props:
 *   size          — pixel size (default 32). Applied to width/height.
 *   className     — extra tailwind classes to add
 *   alt           — accessibility alt text
 *   withWordmark  — if true, renders the full logo (mark + SYNQ wordmark)
 */
export default function SynqLogo({ size = 32, className = "", alt = "SYNQ", withWordmark = false }) {
  const src = withWordmark ? "/synq-logo.png" : "/synq-mark.png";
  const style = withWordmark
    ? { width: size * 2.2, height: size }
    : { width: size, height: size };
  return (
    <img
      src={src}
      alt={alt}
      className={`object-contain select-none ${className}`}
      style={style}
      draggable={false}
    />
  );
}
